'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M1024 352v-352h-352z' }),
        React.createElement('path', { d: 'M352 0h-352v352z' }),
        React.createElement('path', { d: 'M1024 1024v-352l-352 352z' }),
        React.createElement('path', { d: 'M0 1024h352l-352-352z' })
    ));
};